let isTableCheck = false
module.exports = {
  postAuditListcheckbox: isTableCheck,
  typeListcheckbox: isTableCheck,
  supplierListcheckbox: isTableCheck,
  personnelListcheckbox: isTableCheck,
  administratorsListcheckbox: isTableCheck,
  posterListcheckbox: isTableCheck,
  neighborViewlistcheckbox: isTableCheck,
  votingUsersListcheckbox: isTableCheck,
  proprietorNotificationListbox: isTableCheck,
  patrolExceptionListbox: isTableCheck,
  propertyCreditScoreSystemListcheckbox: isTableCheck,
  propertyCreditScoreSystemEvaluationcheckbox: isTableCheck,
  incomeHomeServiceLaborcheckbox: isTableCheck,
  incomeHomeServiceLaborDtlcheckbox: isTableCheck,
  homeServiceCommissioncheckbox: isTableCheck,
  activityManagementListcheckbox: isTableCheck,
  peripheralListcheckbox: isTableCheck,
  seeActivityManagementcheckbox: isTableCheck,
  planeLayoutscheckbox: isTableCheck,
  vacantHouseManagementcheckbox: isTableCheck,
  eagleEyeListcheckbox: isTableCheck,
  preHouseholdInfoManageListcheckbox: isTableCheck,
  NewspaperInfoListcheckbox: isTableCheck,
  communityInfoManagecheckbox: isTableCheck,
  appHouseholdManageListcheckbox: isTableCheck,
  propertyWeekInspectListcheckbox: isTableCheck,
  teleInfosListcheckbox: isTableCheck,
  communityManagementsListkbox: isTableCheck,
  tenantInfosListcheckbox: isTableCheck,
  maintainTypeManagecheckbox: isTableCheck,
  contractTypeManagecheckbox: isTableCheck,
  questionnaireLinksListcheckbox: isTableCheck,
  dutyListCheckbox: isTableCheck,
  propertyManageListCheckbox: isTableCheck,
  personnelAllotmentcheckbox: isTableCheck,
  knowledgeBaseManagementCbx: isTableCheck,
  knowledgeQuerysCbx: isTableCheck,
  roleManagementListCheckbox: isTableCheck,
  responsibilityManagementListCheckbox: isTableCheck,
  jobManagementListCheckbox: isTableCheck,
  resourceLedgerListCheckbox: isTableCheck,
  setRemindercheckbox: isTableCheck,
  taskManageListcheckbox: isTableCheck,
  trialOrderListcheckbox: isTableCheck,
  trialNotescheckbox: isTableCheck,
  trialDetailListcheckbox: isTableCheck,
  venueTypeManagecheckbox: isTableCheck, // 资源点位类型
  venueManagecheckbox: isTableCheck, // 资源点位
  actionname: 'https://zhwy.kmyhwy.cn/mapi/file/upload',  
  actionname_apk: 'https://zhwy.kmyhwy.cn/mapi/uploadApp',  
  // mould: 'http://114.55.43.117:8090/getPic/yezhu.xls', // 下载模板
  mould: 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/yezhu.xls', // 下载模板
  // mouldwy: 'http://114.55.43.117:8090/getPic/wuye.xls', // 下载模板
  mouldwy: 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/wuye.xls',
  mouldKnowlege: 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/zhishiku.xlsx', // 知识库下载模板
  mouldKnowledge: 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/zhishiku.xlsx', // 知识库下载模板
  mouldTaskImport: 'https://zhwyjk.kmyhwy.cn/wxcode/taskImportNew1.xls', // 计划任务导入
  // mouldDevice: 'http://114.55.43.117:8090/getPic/device.xls',
  mouldDevice: 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/device.xls',
  // mouldGardenGrid: 'http://114.55.43.117:8090/getPic/gardenGrid.xls',
  mouldGardenGrid: 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/gardenGrid.xls',
  mouldFeePrepaid: 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/feePrepaid.xlsx',
  mouldFeeCarPrepaid: 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/feeCarPrepaid.xlsx',
  tableDatamaxlength: 20,
  tableDatamaxlength5: 5,
  tableDatamaxlength6: 6,
  tableDatamaxlength9: 9,
  tableDatamaxlength10: 10,
  tableDatamaxlength12: 12,
  tableDatamaxlength15: 15,
  tableDatamaxlength23: 23,
  tableDatamaxlength25: 25,
  tableDatamaxlength30: 30,
  tableDatamaxlength35: 35,
  tableDatamaxlength40: 40,
  tableDatamaxlength50: 50,
  tableDatamaxlength60: 60,
  tableDatamaxlength150: 150,
  tableheight730: 730,
  tableheight720: 720,
  tableheight655: 655,
  tableheight609: 609,
  tableheight552: 552,
  tableheight540: 540,
  tableheight539: 539,
  tableheight530: 530,
  tableheight529: 529,
  tableheight420: 420,
  tableheight400: 400,
  tableheight300: 300,
  tableheight132: 132,
  tableheight120: 120,
  tableheight119: 119,
  tableheight109: 109,
  topicSwitching: false,
  commitname: '查询',
  detailname: '详情',
  deletename: '删除',
  modifyname: '修改',
  // label设置：ws带星，w不带星，数字为字号，例子：c_ws12代表表单最长label字段是带星的12个字
  c_colon: ' : ',
  c_ws1: '90px',
  c_ws2: '100px',
  c_ws3: '110px',
  c_ws4: '120px',
  c_ws5: '130px',
  c_ws6: '140px',
  c_ws7: '150px',
  c_ws8: '160px',
  c_ws9: '170px',
  c_ws10: '180px',
  c_ws11: '190px',
  c_ws12: '200px',
  c_ws13: '250px',
  c_w1: '80px',
  c_w2: '90px',
  c_w3: '100px',
  c_w4: '110px',
  c_w5: '120px',
  c_w6: '130px',
  c_w7: '140px',
  c_w8: '150px',
  c_w9: '160px',
  c_w10: '170px',
  c_w11: '180px',
  c_w12: '190px',
  opr_width1: '100px', // 列表操作列宽度，只有一个操作项
  opr_width2: '150px', // 列表操作列宽度，只有一个操作项
  opr_width3: '200px', // 列表操作列宽度，只有一个操作项
  opr_width4: '250px', // 列表操作列宽度，只有一个操作项
  opr_width6: '400px', // 列表操作列宽度，只有一个操作项
  opr_width8: '500px', // 列表操作列宽度，只有一个操作项

}